import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Onebet } from '../../models/onebet.model';
import { Forex } from '../../models/forex.model';
import { Signal } from '../../models/signal.model';

@Injectable({
  providedIn: 'root'
})
export class SignalsService {


  constructor(
    private afs: AngularFirestore,   // Inject Firestore service
  ) { }

  //Binaries
  getBinariesSignals() {
    return this.afs.collection('signals/binaries/items', ref => ref
      .orderBy('cdate', 'desc')).get();
  }

  createBinariesSignal(signal: Signal) {
    return this.afs.collection('signals/binaries/items').add({
      currency: signal.currency,
      entryPrice: signal.entryPrice,
      stopLoss: signal.stopLoss,
      description: signal.description,
      status: signal.status,
      type: signal.type,
      color: signal.color,
      alias: signal.alias,
      picture: signal.picture,
      tp1: signal.tp1,
      tp2: signal.tp2,
      tp3: signal.tp3,
      tp4: signal.tp4,
      cdate: new Date()
    });
  }

  updateBinariesSignal(signal: Signal) {
    return this.afs.collection('signals/binaries/items').doc(signal.signalId)
    .set({
      currency: signal.currency,
      entryPrice: signal.entryPrice,
      stopLoss: signal.stopLoss,
      description: signal.description,
      status: signal.status,
      type: signal.type,
      color: signal.color,
      alias: signal.alias,
      picture: signal.picture,
      tp1: signal.tp1,
      tp2: signal.tp2,
      tp3: signal.tp3,
      tp4: signal.tp4,
    }, { merge: true });
  }

  deleteBinariesSignal(signal: any) {
    return this.afs.collection('signals/binaries/items').doc(signal).delete();
  }

  //Forex
  getForexSignals() {
    return this.afs.collection('signals/forex/items', ref => ref
      .orderBy('cdate', 'desc')).get();
  }

  createForexSignal(signal: Forex) {
    return this.afs.collection('signals/forex/items').add({
      currency: signal.currency,
      entryPrice: signal.entryPrice,
      stopLoss: signal.stopLoss,
      description: signal.description,
      status: signal.status,
      type: signal.type,
      color: signal.color,
      alias: signal.alias,
      picture: signal.picture,
      tp1: signal.tp1,
      tp2: signal.tp2,
      tp3: signal.tp3,
      tp4: signal.tp4,
      cdate: new Date()
    });
  }

  updateForexSignal(signal: Forex) {
    return this.afs.collection('signals/forex/items').doc(signal.signalId)
      .set({
        currency: signal.currency,
        entryPrice: signal.entryPrice,
        stopLoss: signal.stopLoss,
        description: signal.description,
        status: signal.status,
        type: signal.type,
        color: signal.color,
        alias: signal.alias,
        picture: signal.picture,
        tp1: signal.tp1,
        tp2: signal.tp2,
        tp3: signal.tp3,
        tp4: signal.tp4,
      }, { merge: true });
  }

  deleteForexSignal(signal: any) {
    return this.afs.collection('signals/forex/items').doc(signal).delete();
  }
}
